import { createSelector } from 'reselect';

export const selectPlatformAnnouncements = (state) =>
  state.PlatformAnnouncements;

export const selectPlatformAnnouncementsLoading = createSelector(
  [selectPlatformAnnouncements],
  (beamer) => {
    return beamer.get('loading');
  }
);

export const selectPlatformAnnouncementsPosts = createSelector(
  [selectPlatformAnnouncements],
  (beamer) => {
    return beamer.get('posts');
  }
);

export const selectPlatformAnnouncementsError = createSelector(
  [selectPlatformAnnouncements],
  (beamer) => {
    return beamer.get('error');
  }
);
